export const isRequired = value => (value ? undefined : 'Nutné')

export const isEmail = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Neplatná emailová edresa'
    : undefined

const isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n)

export const isNumber = value =>
  value && !isNumeric(value) ? 'Není číslo' : undefined



// WEBPACK FOOTER //
// ./src/utils/validators.tsx